import reducers from "./StethIOListReducers";

export default reducers;
